import { render } from "./ProgramDataCollection.vue?vue&type=template&id=7ad34dfe"
import script from "./ProgramDataCollection.vue?vue&type=script&lang=js"
export * from "./ProgramDataCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__